import React, {} from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import configs from '../../../../config/config';
import { isMobileLandscape, isMobile } from 'react-device-detect';
import { closeDialog } from '../../../../store/actionCreators/dialog';

const PopUpDialogTemplate = ({
  title,
  iconName,
  text,
  onConfirm,
  onClose,
  onCloseDialog,
  btnNames,
  children,
  className,
  bodyClassName,
  errorHeader,
  btnClasses
}) => {


  const errorDialogClasess = classNames({
    'popup__dialog--error':true,
    'popup__dialog--error--mobile': isMobile && !isMobileLandscape,
    'popup__dialog--error--landscape': isMobileLandscape,
  });

  const closeTop = () => {
    if( onCloseDialog && configs.closeDialogOnlyFromTop ) {
      onCloseDialog();
    } else {
      // onClose ? onClose() : onConfirm ? onConfirm() : '';
    }
  }
  const confirm = () => {
    if( !!onConfirm ) onConfirm();
  }
  const close = () => {
    if( !!onClose ) onClose();
  }

  const primaryClass = btnClasses && btnClasses.confirm ? btnClasses.confirm : ''; 
  const secondaryClass = btnClasses && btnClasses.cancel ? btnClasses.cancel : ''; 
  return (
    <div className={`popup__dialog ${className || ''} ${errorHeader ? errorDialogClasess : ''}`}>
        <i className="icon-clearclose onClose" onClick={ closeTop } ></i>
        <div className={`popup__dialog__title ${errorHeader ? 'popup__dialog__title--error' : ''}`}>
          {iconName && <img src = {`/images/tournamentCasino/dialogs/${iconName}.png`} className={`popup__dialog__icon ${iconName}`} />}
          <div className="popup__dialog__title-text-wrapper">
            {errorHeader && <div className="popup__dialog__icon-wrapper">
                <i className="icon-bang"></i>
              </div>}
            <span className="popup__dialog__title-text">{title}</span>
          </div>
        </div>
        <div className={`popup__dialog__main-context ${bodyClassName || ''} ${children ? 'children' : 'text'}`}>
          {children || text}
        </div>
      {btnNames &&
        <div className={`popup__buttons-row ${iconName}-btn`}>
          {btnNames.confirm && <button className={`btn btn-confirm ${primaryClass}`} onClick={confirm}>{btnNames.confirm}</button>}
          {btnNames.cancel && <button className={`btn btn-cancel ${secondaryClass}`} onClick={close}>{btnNames.cancel}</button>}
        </div>
      }
    </div>
  )
}

export default PopUpDialogTemplate;